import { useState, useEffect } from "react";
import { Link } from "wouter";
import { X } from "lucide-react";

const STORAGE_KEY = "locale_cookie_consent";

export function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) {
        setVisible(true);
      }
    } catch {
      // localStorage blocked (private browsing)
    }
  }, []);

  function accept() {
    try {
      localStorage.setItem(STORAGE_KEY, "accepted");
    } catch {
      // ignore
    }
    setVisible(false);
  }

  function dismiss() {
    try {
      localStorage.setItem(STORAGE_KEY, "dismissed");
    } catch {
      // ignore
    }
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div
      role="region"
      aria-label="Cookie notice"
      className="fixed bottom-0 left-0 right-0 z-50 bg-primary text-white shadow-2xl"
    >
      <div className="container mx-auto px-4 py-4 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <p className="text-sm text-white/90 leading-relaxed flex-1">
          We use essential cookies to make LOCALE work, and optional analytics cookies
          to understand how you use the site. Read our{" "}
          <Link
            href="/privacy"
            className="text-white underline font-semibold hover:text-white/80"
            onClick={dismiss}
          >
            Privacy Policy
          </Link>{" "}
          for details.
        </p>
        <div className="flex items-center gap-3 shrink-0">
          <button
            onClick={dismiss}
            className="text-sm text-white/70 hover:text-white underline transition-colors"
            aria-label="Use essential cookies only"
          >
            Essential only
          </button>
          <button
            onClick={accept}
            className="bg-accent text-accent-foreground text-sm font-bold px-5 py-2.5 hover:bg-accent/90 transition-colors"
            aria-label="Accept all cookies"
          >
            Accept All
          </button>
          <button
            onClick={dismiss}
            className="text-white/60 hover:text-white transition-colors p-1"
            aria-label="Close cookie notice"
          >
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}
